import React from 'react';
import './sitemap.scss'; // Adjust path if needed
import logo from '../assets/fitoja-logo.png'; // Make sure Webpack/Vite handles this import

const Sitemap = () => {
  return (
    <div>
      <header>
        <img className="img" src={logo} alt="Fitoja Logo" />
      </header>

      <main>
        <h1>Website Sitemap</h1>

        <section>
          <h2>Pages</h2>
          <ul>
            <li><a href="https://www.fitoja.in/">Home</a></li>
            <li><a href="https://www.fitoja.in/about-us">About Us</a></li>
            <li><a href="https://www.fitoja.in/contact-us">Contact Us</a></li>
            <li><a href="https://www.fitoja.in/customer-support">Customer Support</a></li>
            <li><a href="https://www.fitoja.in/privacy-policy">Privacy Policy</a></li>
            <li><a href="https://www.fitoja.in/terms-conditions">Terms & Conditions</a></li>
            <li><a href="https://www.fitoja.in/blogs">Blog</a></li>
          </ul>
        </section>
      </main>
      <br></br>
      <br></br>
      <footer className='sitemap-footer'>
        &copy; 2025 Fitoja.in. All rights reserved.
      </footer>
    </div>
  );
};

export default Sitemap;
